import React from 'react'
import Skeleton from '@material-ui/lab/Skeleton'
import { useListedItemPlaceholderStyles } from './listed-item-placeholder.styles'
import { Card, CardContent } from '@material-ui/core'

export const ListedItemPlaceholder: React.FC = () => {
  const classes = useListedItemPlaceholderStyles()
  return (
    <Card className={classes.card} elevation={0}>
      <CardContent className={classes.cardContent}>
        <Skeleton animation="wave" className={classes.image} />
        <div className={classes.textHolder}>
          <Skeleton
            animation="wave"
            width="60%"
            className={classes.textLine}
          />
          <Skeleton
            animation="wave"
            width="50%"
            className={classes.textLine}
          />
          <Skeleton
            animation="wave"
            width="70%"
            className={classes.textLine}
          />
        </div>
      </CardContent>
    </Card>
  )
}
